import { Outlet } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useRefreshMutation } from "./authApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { selectCurrentToken, setCredentials } from "./authSlice";
import { Box, CircularProgress } from "@mui/material";

const PersistLogin = () => {
  const token = useSelector(selectCurrentToken);
  const effectRan = useRef(false);

  const [isReady, setIsReady] = useState(!!token);

  const [refresh] = useRefreshMutation();

  const dispatch = useDispatch();

  useEffect(() => {
    if (effectRan.current === true || process.env.NODE_ENV !== "development") {
      // React 18 Strict Mode

      const verifyRefreshToken = async () => {
        try {
          const { data } = await refresh();
          if (data) {
            dispatch(setCredentials({ ...data }));
          }
          // console.log("PersistLogin: Refresh token verified successfully data:", data);
        } catch (err) {
          console.error(err);
        } finally {
          setIsReady(true);
        }
      };

      if (!token) {
        verifyRefreshToken();
      } else {
        setIsReady(true);
      }
    }

    return () => (effectRan.current = true);

    // eslint-disable-next-line
  }, []);

  if (!isReady) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return <Outlet />;
};
export default PersistLogin;
